<template>
  <section class="s-compnay">
    <div class="company-container">
      <h2 v-html="lang === 'it' ? 'Gruppo' : 'Group'"></h2>
      <div class="blocks">
        <div class="block block-1">
          <img :src="data.columns[0].image" :alt="data.columns[0].title" />
          <p v-html="data.columns[0].text">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quam aliquid ipsam repudiandae ad suscipit eaque autem ullam, non in nobis temporibus quia.
          </p>
        </div>
        <div class="block block-2">
          <img :src="data.columns[1].image" :alt="data.columns[1].title" />
          <p v-html="data.columns[1].text">
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nobis ea voluptate accusamus blanditiis rerum animi nisi error aut. Explicabo, ipsa?
          </p>
        </div>
        <div class="block block-3">
          <img :src="data.columns[2].image" :alt="data.columns[2].title" />
          <p v-html="data.columns[2].text">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Est velit itaque fugiat impedit corrupti, unde molestias eius.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { app } from '@/utils/store';
import nodata from './company.json';

const data = nodata[app.language];

export default {
  name: 'Company',

  data() {
    return {
      lang: app.language,
      data,
    };
  },
};
</script>
